export default {
    "messages": {
        "no-data": "Não há dados diponíveis",
        "latina": {
            "player": {
                "share": "Partilhar",
                "share-message": "Estou a ouvir {song}-{artist} na Rádio Latina",
                "no-track-info": "Sem informação da música",
                "no-artist": "Sem artista",
                "last-tracks": {
                    "title": "Últimas Músicas"
                }
            }
        },
        "service": {
            "traffic":{
                "alert": {
                    "title": "Informações de trânsito",
                    "none": "Trânsito normal"
                },
                "trafficcamera": {
                    "title": "Web Cam"
                },
                "parking": {
                    "title": "Estacionamento",
                    "defaultDistrict": "Centre",
                    "column": {
                        "carParks": "Parques de estacionamento",
                        "capacity": "Capacidade",
                        "occupied": "Completo",
                        "free": "Livre",
                        "trend": "Tendência"
                    },
                    "closed": "encerramento"
                },
                "no-data": "não há dados"
            },
            "sport-results": {
                "sport-name": {
                    "footballNational": "Futebol nacional",
                    "footballInternational": "Futebol internacional",
                    "basketball": "Basquetebol",
                    "handball": "Andebol",
                    "volleyball": "Voleibol",
                    "tableTennis": "Ténis de mesa"
                },
                "title": {
                    "prefix": "Resultados da jornada",
                    "day": "ª",
                    "suffix": "",
                    "mobile-prefix": "Resultados",
                    "mobile-suffix": "jornada"
                },
                "ranking": {
                    "title": "Classificação geral depois da jornada",
                    "mobile-title": "Classificação (da jornada)",
                    "position": "Pos.",
                    "team": "Equipa",
                    "played": "J.",
                    "won": "V.",
                    "draw":"E.",
                    "lost": "D.",
                    "difference": "Dif.",
                    "points": "Pts"
                }
            },
            "commons": {
                "luxembourgCitySouth": "Cidade do Luxemburgo (Sul)",
                "germanyBorder": "Alemanha",
                "franceBorder": "França",
                "luxembourgCityHollerich": "Luxemburgo Hollerich",
                "eschSurAlzette": "Esch-sur-Alzette",
                "belgiumBorder": "Bélgica",
                "grunewald": "Grunewald",
                "colmarBerg": "Colmar-Berg",
                "sarrebruck": "Sarrebruck",
                "longwy": "Longwy",
                "no-data": "Não há dados diponíveis"
            },
            "events": {
                "countries": {
                    "lu": "Luxemburgo",
                    "de": "Alemanha",
                    "fr": "França",
                    "be": "Bélgica",
                    "none": ""
                },
                "upcoming": "Eventos ocasionais",
                "permanents": "Eventos permanentes",
                "timeFromFormat": "de",
                "timeToFormat": "au",
                "dateStartFormat": "[De] ll",
                "dateStartingFromFormat": "[A partir de] ll",
                "dateEndFormat": " [a] ll",
                "allEvents": "Todos os eventos",
                "no-events": "Nenhum evento disponível",
                "categories": {
                    "all": "Geral",
                    "concerts": "Concertos",
                    "nightlife": "Saídas à noite",
                    "dance": "Dança",
                    "opera_theatre": "Ópera & Teatro",
                    "sport": "Desporto",
                    "spectacle": "Espectáculos",
                    "festivity_festival": "Festas & Festivais",
                    "conference_seminar": "Conferências & Seminários",
                    "exhibition": "Exposições",
                    "family_kids": "Família",
                    "other": "Outros"
                },
                "event-details": {
                    "show-more-dates": "Mostrar mais datas or Outras datas disponíveis",
                    "show-map": "Mostrar mapa or Mostrar localização",
                    "free": "Grátis",
                    "fallback-description": "A descrição não se encontra disponível no seu idioma.",
                    "no-description": "Sem descrição",
                    "canceled": "Cancelado",
                    "monday": "segunda-feira",
                    "tuesday": "terça-feira",
                    "wednesday": "quarta-feira",
                    "thursday": "quinta-feira",
                    "friday": "sexta-feira",
                    "saturday": "sábado",
                    "sunday": "domingo",
                    "closed": "encerramento"
                }
            }
        },
        "commons": {
            "delete": "Apagar",
            "show-more": "mostrar mais"
        },
        "share-buttons": {
            "copy-to-clipboard-message": "O link foi copiado para a sua área de transferência."
        },
        "homepage": {
            "new-articles": "Novos artigos disponiveis"
        },
        "notifications-page": {
            "subscription": {
                "success": {
                    "subscribe": "Subscreveu as nossas notificações com sucesso",
                    "unsubscribe": "foi desconectado com sucesso"

                },
                "fail": "Desculpe, não foi possível subscrever o nosso serviço. Por favor  procure informações adicionais nas perguntas mais frequentes (FAQ)."
            },
            "permission": {
                "blocked": "Não pode receber as nossas notificações, porque estas mesmas estão bloqueadas. Por favor atualize as configurações no seu navegador para permitir notificações."
            },
            "unsupported-browser": "O seu navegador não suporta as nossas notificações."
        },
        "services": {
            "announcements": {
                "births": "Nascimentos",
                "weddings": "Casamentos",
                "obituaries": "Necrologias"
            }
        },
    }
};



// WEBPACK FOOTER //
// ./js/i18n/TranslationPortuguese.js